<template>
  <v-row>
    <v-col cols="12" class="display-1 font-weight-medium">
      Education
    </v-col>

    <v-col cols="12" class="text-left">
      <v-card class="pa-5" style="border-radius: 20px;">
        <v-card-title style="word-wrap: break-word; word-break: normal;" class="mb-0 pb-5">
          Full Stack Certification
        </v-card-title>

        <v-card-subtitle class="font-weight-medium colored mb-1">
          <span class="title font-italic">freeCodeCamp</span><br/>
          2020 - 2020
        </v-card-subtitle>

        <v-card-text class="font-weight-medium body-1" style="line-height: 1.6;">
          Certification composed of 6 certifications:<br/>
          <span class="font-weight-bold black--text">Responsive Web Design:</span> HTML (accessibility), CSS (flexbox, grid).<br/>
          <span class="font-weight-bold black--text">JavaScript Algorithms and Data Structures:</span> JS (ES6, RegEx).<br/>
          <span class="font-weight-bold black--text">Front End Libraries:</span> Bootstrap, jQuery, Sass, React/Redux.<br/>
          <span class="font-weight-bold black--text">Data Visualization:</span> D3, APIs and AJAX.<br/>
          <span class="font-weight-bold black--text">APIs and Microservices:</span> npm, Node, Express, MongoDB, Mongoose.<br/>
          <span class="font-weight-bold black--text">Information Security and Quality Assurance:</span> Helmet, Chai, advanced Node and Express.<br/>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12" class="text-left">
      <v-card class="pa-5" style="border-radius: 20px;">
        <v-card-title style="word-wrap: break-word; word-break: normal;" class="mb-0 pb-5">
          History, Philosophy and Science Mediation (MSc)
        </v-card-title>

        <v-card-subtitle class="font-weight-medium colored mb-1">
          <span class="title font-italic">Bordeaux 3 University</span><br/>
          2014 - 2016
        </v-card-subtitle>

        <v-card-text class="font-weight-medium body-1" style="line-height: 1.6;">
          <span class="font-weight-bold black--text">First year:</span> Consolidation of knowledge in philosophy, communication of science, design and writing.<br/>
          <span class="font-weight-bold black--text">Second year:</span> Year of practice with creation of an exhibition, a conference, a newspaper and multiple communication plans.<br/>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12" class="text-left">
      <v-card class="pa-5" style="border-radius: 20px;">
        <v-card-title style="word-wrap: break-word; word-break: normal;" class="mb-0 pb-5">
          Physics and Application to the Energy (BsC)
        </v-card-title>

        <v-card-subtitle class="font-weight-medium colored mb-1">
          <span class="title font-italic">Toulouse III University</span><br/>
          2008 - 2013
        </v-card-subtitle>

        <v-card-text class="font-weight-medium body-1" style="line-height: 1.6;">
          <span class="font-weight-bold black--text">First year:</span> Physics, Chemistry and Automatics, option: astrophysics<br/>
          <span class="font-weight-bold black--text">Second year:</span> Physics, Chemistry<br/>
          <span class="font-weight-bold black--text">Third year:</span> Physics and Application to the Energy, option: diffusion of scientific knowledge, option: astrophysics
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {

}
</script>

<style>
.colored {
  color: rgba(79, 179, 108) !important;
}
</style>